export const PROGRAM_PREFIX = 'p-';
export const APPLICATION_PREFIX = 'api-';
export const ESI_PREFIX = 'esi-';
export const SSI_PREFIX = 'ssi-';
